import { useTranslation } from "react-i18next";
import { Check, X, MailX } from "lucide-react";
import { NeuButton, NeuInput } from "../../components/neu/Neu";

// صف طلب واحد: أزرار قبول + رفض + رفض سريع بسبب "email مستخدم".
export const SignupRow = ({ r, busy, reason, setReason, onApprove, onReject }) => {
  const { t } = useTranslation();
  return (
    <li data-testid={`signup-request-${r.id}`}
        className="rounded-2xl border border-border/50 px-4 py-3 shadow-neu-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="font-bold">{r.company_name}</p>
          <p className="text-xs text-muted-foreground">
            {r.contact_name} · {r.contact_email}
            {r.phone ? ` · ${r.phone}` : ""}
            {r.country ? ` · ${r.country}` : ""}
          </p>
        </div>
        <span className="font-mono text-sm text-primary">
          {t("platformExtra.employees")}: {r.employee_count}
        </span>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <NeuInput className="max-w-xs" data-testid={`signup-reason-${r.id}`}
                  placeholder={t("requests.reasonPlaceholder")}
                  value={reason} onChange={(e) => setReason(e.target.value)} />
        <NeuButton variant="primary" disabled={busy}
                   data-testid={`signup-approve-${r.id}`}
                   className="flex items-center gap-2" onClick={onApprove}>
          <Check className="h-4 w-4" /> {t("platformExtra.approve")}
        </NeuButton>
        <NeuButton variant="danger" disabled={busy}
                   data-testid={`signup-reject-${r.id}`}
                   className="flex items-center gap-2" onClick={() => onReject(reason)}>
          <X className="h-4 w-4" /> {t("platformExtra.reject")}
        </NeuButton>
        <NeuButton disabled={busy}
                   data-testid={`signup-reject-email-${r.id}`}
                   className="flex items-center gap-2 text-warning"
                   onClick={() => onReject("email_in_use")}>
          <MailX className="h-4 w-4" /> {t("platformExtra.rejectEmailInUse")}
        </NeuButton>
      </div>
    </li>
  );
};
